const config = {
  googleClientId:
    "282817292369-jir9raf3mr4al5ilnrsh5gbaerdbtqns.apps.googleusercontent.com",
  distributerId: "663b39b3ab4ec46c6ebcf258",
};
export default config;
